<template>
<div class="containers">
    <div class="search-area">
        <CRow class="mb-2 mt-4">
            <CCol sm="12">
                <h5 class="font-weight-bold">Data Rekapitulasi Daftar Magang Bulan {{selectedBulan.text}} Tahun {{selectedTahun.text}}</h5>
            </CCol>
        </CRow>
        <hr/>
        <CRow class="mt-5">
            <CCol sm="12">
                <CRow>
                    <CCol sm="2">
                        Approve Supervisor
                    </CCol>
                    <CCol sm="9 text-left">
                        <span v-if="approveSDM=='Y' && datas.length != 0"><span class="font-weight-bold">: Disetujui</span> oleh <span class="font-weight-bold">{{namaApproveSDM}}</span> pada <span class="font-weight-bold">{{tanggalApproveSDM}}</span></span>
                        <span v-if="approveSDM=='T' && datas.length != 0">: <span class="font-weight-bold">Belum Disetujui</span> oleh <span class="font-weight-bold">Supervisor</span></span>
                        <span v-if="datas.length == 0">: -</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="2">
                        Approve Manager
                    </CCol>
                    <CCol sm="9 text-left">
                        <span v-if="approveSuperSDM=='Y' && datas.length != 0"><span class="font-weight-bold">: Disetujui</span> oleh <span class="font-weight-bold">{{namaApproveSuperSDM}}</span> pada <span class="font-weight-bold">{{tanggalApproveSuperSDM}}</span></span>
                        <span v-if="approveSuperSDM=='T' && datas.length != 0">: <span class="font-weight-bold">Belum Disetujui</span> oleh <span class="font-weight-bold">Manager</span></span>
                        <span v-if="datas.length == 0">: -</span>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow v-if="flagSDM == 'Y' || (flagSDM == 'T' && approveSDM == 'Y')" class="no-gutters mt-5">
            <CCol style="padding-right:4px" sm="3">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="3">
                <model-select :options="searchDataFungsi"
                    style="background-color:rgba(249, 250, 252, 1)"
                    class="form-control model-select"
                    v-model="searchSelectedFungsi"
                    placeholder="Pilih Status Fungsi">
                </model-select>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataBulan" class="form-control" v-model="selectedBulan" placeholder="Bulan"></model-select>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataYear" class="form-control" v-model="selectedTahun" placeholder="Tahun"></model-select>
            </CCol>
            <CCol style="padding-left:6px" sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
        <CRow v-else-if="flagSDM == 'T' || (flagSDM == 'T' && approveSDM == 'T')" class="no-gutters mt-5">
            <CCol style="padding-right:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <model-select :options="searchDataFungsi"
                    style="background-color:rgba(249, 250, 252, 1)"
                    class="form-control model-select"
                    v-model="searchSelectedFungsi"
                    placeholder="Pilih Status Fungsi">
                </model-select>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataBulan" class="form-control" v-model="selectedBulan" placeholder="Bulan"></model-select>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataYear" class="form-control" v-model="selectedTahun" placeholder="Tahun"></model-select>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataApprove" class="form-control" v-model="approve" placeholder="Pilih Status"></model-select>
            </CCol>
            <CCol style="padding-left:6px" sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="4">
                <CButton class="mr-4" v-if="approveSDM == 'Y' && approveSuperSDM == 'Y' && datas.length != 0" @click="exportPdf()" color="danger" variant="outline">Export PDF</CButton>
                <CButton class="mr-4" v-if="approveSDM != 'Y' && approveSuperSDM != 'Y' && flagSDM != 'Y' && approveSDM != ''" @click="approvedModal = true" color="primary" variant="outline">Approve Supervisor</CButton>
                <CButton class="mr-4" v-if="approveSDM == 'Y' && approveSuperSDM != 'Y' && flagSDM != 'Y' && approveSDM != ''" @click="approveSpv()" color="primary" variant="outline">Edit Daftar</CButton>
                <CButton class="mr-4" v-if="approveSDM == 'Y' && approveSuperSDM != 'Y' && flagSDM == 'Y' && aprroveSuperSDM != ''" @click="approvedModal = true" color="primary" variant="outline">Approve Manager</CButton>
                <CButton class="mr-4" v-if="datas.length != 0" @click="getDownload()" color="success" variant="outline">Export Excel</CButton>
            </CCol>
            <CCol sm="5">
                <!-- <img class="mr-4 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/> -->
                <!-- <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/> -->
                <img class="mr-4 mt-1" title="refresh" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
            <CCol sm="3">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
            </CCol>
        </CRow>
    </div>
    <Tables v-if="flagSDM == 'Y' || (flagSDM == 'T' && approveSDM == 'Y')" @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    <TablesSDM v-else-if="flagSDM == 'T' || (flagSDM == 'T' && approveSDM == 'T')" @sort="sorting" :data="datas" @cek="cekData" @cekAll="cekAllData" :checkingAll="checkAll" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></TablesSDM>
    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="approvedModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Konfirmasi Persetujuan Daftar Magang</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="approvedModal = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        Persetujuan daftar magang
                    </CCol>
                </CRow>
                <CRow class="mt-5">
                    <CCol sm="12">
                        <label>Masukan Keterangan</label>
                        <textarea class="form-control w-100" placeholder="Keterangan" v-model="keteranganSDM"/>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton @click="approvedModal = false" class="w-100" color="secondary" variant="outline">Kembali</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="approveSpv()" class="w-100" color="primary" variant="outline">Setuju</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import TablesSDM from '../../../component/tableMagangSDM'
import Tables from '../../../component/tableMagang'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'

const xlsx = require('json-as-xlsx')
export default {
components: {
    ModelSelect,
    Tables,
    TablesSDM
},
data() {
    return {
        approvedModal: false,
        // data search pegawai
        dataPegawai: [],
        titlePegawai:"Pilih Pegawai",
        selectedItemPegawai: null,
        selectedPegawai: 0,
        queryPegawai: '',
        visiblePegawai: false,
        idPegawai: '',

        approveSDM: '',
        approveSuperSDM: '',
        tanggalApproveSDM: '',
        tanggalApproveSuperSDM: '',
        namaApproveSDM: '',
        namaApproveSuperSDM: '',

        // datas
        refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
        downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
        closeIcon: require('../../../assets/menu/icon_close.svg'),
        moreIcon: require('../../../assets/menu/icon_more.svg'),
        dataTh: ['Cek', 'Nama / NIP', 'HKP', 'Uang Saku', 'Uang Makan', 'Komunikasi', 'Reimburse', 'Fungsi', 'Total'],
        dataTd: ['approve', ['nama', 'nik'], 'hkp', 'uangSaku', 'uangMakan', 'uangKomunikasi', 'reimburse', 'fungsi', 'gaji'],
        styleTable: ['50px', '175px', '50px', '100px', '100px', '100px', '100px', '75px', '100px' ],
        classReload: 'reloadOff',
        datas: [],
        checkAll: '',
        selectedBulan: {
            value: '',
            text: ''
        },
        selectedTahun: {
            value: '',
            text: ''
        },
        tanggal: new Date(),
        dataYear: [],
        dataBulan: [],
        searchDataFungsi: [],
        searchSelectedFungsi: {
            text: '',
            value: ''
        },
        dataApprove: [],
        approve: {
            text: '',
            value: ''
        },


        // paging
        page: 1,
        size: 20,
        totalRow: 0,
        totalPage: 1,
        firstPage: 0,
        lastPage: 0,

        // error
        errorMessage: '',
        flagSDM: 'T',
        flagSearch: false
    }
},
computed: {
    matchesPegawai() {
        if (this.queryPegawai == '') {
            return [];
        }
        return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
    },
},
watch: {
    page() {
        window.scroll({
            top:0,
            left: 0,
            behavior: 'smooth'
        });
    },
    approve() {
        this.flagSearch = true
    },
    queryPegawai() {
        if(this.queryPegawai == '') {
            this.idPegawai = ''
        }
        this.flagSearch = true
        this.getDataPegawai()
    },
    selectedBulan() {
        this.flagSearch = true
    },
    selectedTahun() {
        this.flagSearch = true
    },
    searchSelectedFungsi() {
        this.flagSearch = true
    },
    approvedModal() {
        if(this.approvedModal == false) {
            this.keteranganSDM = ''
        }
    },
},
methods: {
    /**
        * SEARCH PEGAWAI
        */
    getDataPegawai() {
        let payload = {
            bidang: '',
            jabatan: '',
            limit: 10,
            nama: this.queryPegawai,
            pageIn: 1,
            pegawaiId: '',
            tipePegawai: '3'
        }
        DataApi.post("pegawai/get", payload)
        .then(res => {
            this.dataPegawai = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for(i=0;i<tempData.length;i++) {
                let onPush = {
                    value: tempData[i].idPegawai,
                    text: tempData[i].nama + ' - ' + tempData[i].nik
                }
                this.dataPegawai.push(onPush)
            }
        })
    },

    toggleVisiblePegawai() {
        this.visiblePegawai = true;
    },
    hidePegawai() {
        this.visiblePegawai = false;
    },
    toggleCloseVisiblePegawai() {
        setTimeout(this.hidePegawai, 1000);
    },
    itemClickedPegawai(index) {
        this.selectedPegawai = index;
        this.selectItemPegawai();
    },
    selectItemPegawai() {
        if (!this.matchesPegawai.length) {
        return;
        }
        this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
        this.visiblePegawai = false;
        this.queryPegawai = this.selectedItemPegawai.text
        this.idPegawai = this.selectedItemPegawai.value
        if (this.shouldReset) {
        this.queryPegawai = '';
        this.selectedPegawai = 0;
        }
    },
    upPegawai() {
        if (this.selectedPegawai == 0) {
        return;
        }
        this.selectedPegawai -= 1;
        this.scrollToItemPegawai();
    },
    downPegawai() {
        if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
        return;
        }
        this.selectedPegawai += 1;
        this.scrollToItemPegawai();
    },
    scrollToItemPegawai() {
        this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
    },


    sorting(value) {
        if(value == 0) {
            function compare(a,b) {
                if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                    return -1
                }
                if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        } else if(value == 1) {
            function compare(a,b) {
                if (a.hkp.toLowerCase() < b.hkp.toLowerCase()) {
                    return -1
                }
                if (a.hkp.toLowerCase() > b.hkp.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        } else if(value == 2) {
            function compare(a,b) {
                if (a.uangSaku.toLowerCase() < b.uangSaku.toLowerCase()) {
                    return -1
                }
                if (a.uangSaku.toLowerCase() > b.uangSaku.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        } else if(value == 3) {
            function compare(a,b) {
                if (a.uangMakan.toLowerCase() < b.uangMakan.toLowerCase()) {
                    return -1
                }
                if (a.uangMakan.toLowerCase() > b.uangMakan.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        } else if(value == 4) {
            function compare(a,b) {
                if (a.uangKomunikasi.toLowerCase() < b.uangKomunikasi.toLowerCase()) {
                    return -1
                }
                if (a.uangKomunikasi.toLowerCase() > b.uangKomunikasi.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        } else if(value == 5) {
            function compare(a,b) {
                if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                    return -1
                }
                if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        } else if(value == 6) {
            function compare(a,b) {
                if (a.gaji.toLowerCase() < b.gaji.toLowerCase()) {
                    return -1
                }
                if (a.gaji.toLowerCase() > b.gaji.toLowerCase()) {
                    return 1
                }
                return 0
            }
            return this.datas.sort(compare)
        }
    },
    getDownload() {
        if(this.datas.length != 0) {
            this.$store.state.loadingScreen = true
            let approve = 'T'

            if(this.flagSDM == 'Y') {
                approve = 'Y'
            } else {
                approve = this.approve.value
            }
            let payload = {
                bulan: this.selectedBulan.value,
                idPegawai: this.idPegawai,
                limit: this.totalRow,
                pageIn: 1,
                tahun: this.selectedTahun.value,
                fungsi: this.searchSelectedFungsi.value,
                approve: approve
            }
            DataApi.post("salary/magang/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Daftar Magang' + this.selectedBulan.value + '-' + this.selectedTahun.value
                    let data = [
                        {
                            sheet: 'Daftar',
                            columns: [
                                { label: 'Nama', value: 'nama' },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Fungsi', value: 'fungsi' },
                                { label: 'Approve', value: 'keteranganApprove' },
                                { label: 'Divisi/Regional', value: 'divisi' },
                                { label: 'Periode Uang Saku Magang', value: 'periode' },
                                { label: 'IO', value: 'io' },
                                { label: 'CoA', value: 'coa' },
                                { label: 'PRK', value: 'prk' },
                                { label: 'Cost Center', value: 'costCenter' },
                                { label: 'Nomor Rekening', value: 'noRek' },
                                { label: 'Bank', value: 'namaBank' },
                                { label: 'Nama Pemilik Rekening', value: 'namaPemilikRek' },
                                { label: 'Uang Saku', value: 'uangSaku' },
                                { label: 'Uang Makan', value: 'uangMakan' },
                                { label: 'Uang Komunikasi', value: 'uangKomunikasi' },
                                { label: 'BPJS Kesehatan', value: 'bpjs' },
                                { label: 'Suplisi', value: 'suplisi' },
                                { label: 'Pengurang Uang Saku', value: 'pengurang' },
                                { label: 'Total yang Dibayarkan', value: 'gaji' },
                                { label: 'Nomor Rekening', value: 'noRek' },
                                { label: 'Bank', value: 'namaBank' },
                                { label: 'Nama Pemilik Rekening', value: 'namaPemilikRek' },
                                { label: 'Keterangan', value: 'keterangan' },
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        }
    },
    getData() {
        if(this.flagSearch == true) {
                this.page = 1
            }
        this.$store.state.loadingScreen = true
        let approve = 'T'

        if(this.flagSDM == 'Y') {
            approve = 'Y'
        } else {
            approve = this.approve.value
        }
        let payload = {
            bulan: this.selectedBulan.value,
            idPegawai: this.idPegawai,
            limit: this.size,
            pageIn: this.page,
            tahun: this.selectedTahun.value,
            fungsi: this.searchSelectedFungsi.value,
            approve: approve
        }
        DataApi.post("salary/magang/lihat", payload)
        .then(res => {
            let response = res.data
            if(response.success == true) {
                this.approveSDM = response.data.approveSdm
                this.approveSuperSDM = response.data.approveSuperSdm
                this.tanggalApproveSDM = response.data.tanggalApproveSdm
                this.tanggalApproveSuperSDM = response.data.tanggalApproveSuperSdm
                this.namaApproveSDM = response.data.namaApproverSdm
                this.namaApproveSuperSDM = response.data.namaApproverSuperSdm
                this.checkAll = response.data.checkAll

                if(this.flagSDM == 'Y' && this.approveSdm != 'Y') {
                    this.datas = []
                    this.errorMessage = 'Maaf, Supervisor belum menyetujui daftar magang untuk bulan ini'
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalRow = 0
                    this.totalPage = 1
                }

                if(this.flagSDM == 'Y') {
                    this.dataTh = ['Nama / NIP', 'HKP', 'Uang Saku', 'Uang Makan', 'Komunikasi', 'Reimburse', 'Fungsi', 'Total']
                    this.dataTd = [['nama', 'nik'], 'hkp', 'uangSaku', 'uangMakan', 'uangKomunikasi', 'reimburse', 'fungsi', 'gaji']
                    this.styleTable = ['175px', '50px', '100px', '100px', '100px', '100px', '75px', '100px' ]

                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else if(this.flagSDM == 'T' && this.approveSDM != 'Y') {
                    this.dataTh = ['Cek', 'Nama / NIP', 'HKP', 'Uang Saku', 'Uang Makan', 'Komunikasi', 'Reimburse', 'Fungsi', 'Total']
                    this.dataTd = ['approve', ['nama', 'nik'], 'hkp', 'uangSaku', 'uangMakan', 'uangKomunikasi', 'reimburse', 'fungsi', 'gaji']
                    this.styleTable = ['50px', '175px', '50px', '100px', '100px', '100px', '100px', '75px', '100px' ]
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else if(this.flagSDM == 'T' && this.approveSDM == 'Y') {
                    this.dataTh = ['Nama / NIP', 'HKP', 'Uang Saku', 'Uang Makan', 'Komunikasi', 'Reimburse', 'Fungsi', 'Total']
                    this.dataTd = [['nama', 'nik'], 'hkp', 'uangSaku', 'uangMakan', 'uangKomunikasi', 'reimburse', 'fungsi', 'gaji']
                    this.styleTable = ['175px', '50px', '100px', '100px', '100px', '100px', '75px', '100px' ]

                    this.getApproveSDM()
                }
            } else {
                this.datas = []
                this.errorMessage = response.message
                this.firstPage = 0
                this.lastPage = 0
                this.totalRow = 0
                this.totalPage = 1
            }
            this.flagSearch = false
            this.$store.state.loadingScreen = false
        })
    },
    getApproveSDM() {
        this.$store.state.loadingScreen = true
        
        let payload = {
            bulan: this.selectedBulan.value,
            idPegawai: this.idPegawai,
            limit: this.size,
            pageIn: this.page,
            tahun: this.selectedTahun.value,
            fungsi: this.searchSelectedFungsi.value,
            approve: 'Y'
        }
        DataApi.post("salary/magang/lihat", payload)
        .then(res => {
            let response = res.data
            if(response.success == true) {
                this.datas = response.data.data
                this.totalRow = response.data.totalRow
                this.firstPage = (((this.page - 1) * this.size) + 1 )
                this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                this.totalPage = Math.floor(this.totalRow/this.size)
                let modAr = this.totalRow%this.size
                if(modAr != 0) {
                    this.totalPage = this.totalPage + 1
                } else {
                    //
                }
            } else {
                this.datas = []
                this.errorMessage = response.message
                this.firstPage = 0
                this.lastPage = 0
                this.totalRow = 0
                this.totalPage = 1
            }
            this.$store.state.loadingScreen = false
        })
    },
    findData() {
        this.getData()
    },
    reload() {
        this.selectedBulan.value = ''
        this.selectedBulan.text = ''
        this.selectedTahun.value = ''
        this.selectedTahun.text = ''
        this.queryPegawai = ''
        this.idPegawai = ''
        this.approve.value = ''
        this.approve.text = 'Semua'
        this.searchSelectedFungsi.value = ''
        this.searchSelectedFungsi.text = 'Semua'
        this.flagSearch = true
        this.getDataBulan()
        this.getSearchDataFungsi()
        this.getDataBulan()
        this.getDataTahun()
        this.getDataApprove()
        this.setDate()
        if (this.classReload == 'reloadOff') {
            this.classReload = 'reloadOn'
        } else {
            this.classReload = 'reloadOff'
        }
        this.getData()
    },
    movePage(direction) {
        if(direction == 'prev') {
            this.page = this.page -  1
        } else {
            this.page = this.page +  1
        }
        this.getData()
    },
    validatePage(page) {
        if(page > this.totalPage) {
            this.page = this.totalPage
        }
    },
    getSearchDataFungsi() {
        this.searchDataFungsi = [
            { text: 'Semua', value: '' },
            { text: 'Aset', value: 'Aset' },
            { text: 'Coop', value: 'Coop' },
            { text: 'Aktivasi', value: 'Aktivasi' },
        ]
    },
    getDataBulan() {
        this.dataBulan = [
            {
                text: 'Januari',
                value: '1'
            },
            {
                text: 'Februari',
                value: '2'
            },
            {
                text: 'Maret',
                value: '3'
            },
            {
                text: 'April',
                value: '4'
            },
            {
                text: 'Mei',
                value: '5'
            },
            {
                text: 'Juni',
                value: '6'
            },
            {
                text: 'Juli',
                value: '7'
            },
            {
                text: 'Agustus',
                value: '8'
            },
            {
                text: 'September',
                value: '9'
            },
            {
                text: 'Oktober',
                value: '10'
            },
            {
                text: 'November',
                value: '11'
            },
            {
                text: 'Desember',
                value: '12'
            },
        ]
    },
    getDataTahun() {
        let now = this.tanggal.getFullYear()
        this.dataYear = [
            {
                text: now-5,
                value: now-5
            },
            {
                text: now-4,
                value: now-4
            },
            {
                text: now-3,
                value: now-3
            },
            {
                text: now-2,
                value: now-2
            },
            {
                text: now-1,
                value: now-1
            },
            {
                text: now,
                value: now
            },
            {
                text: now+1,
                value: now+1
            },
            {
                text: now+2,
                value: now+2
            },
            {
                text: now+3,
                value: now+3
            },
            {
                text: now+4,
                value: now+4
            },
            {
                text: now+5,
                value: now+5
            }
        ]
    },
    setDate() {
        let month = this.tanggal.getMonth() + 1
        let year = this.tanggal.getFullYear()
        this.selectedTahun.value = year
        this.selectedTahun.text = year
        if(month == 1) {
            this.selectedBulan.value = '1'
            this.selectedBulan.text = 'Januari'
        }
        if(month == 2) {
            this.selectedBulan.value = '2'
            this.selectedBulan.text = 'Februari'
        }
        if(month == 3) {
            this.selectedBulan.value = '3'
            this.selectedBulan.text = 'Maret'
        }
        if(month == 4) {
            this.selectedBulan.value = '4'
            this.selectedBulan.text = 'April'
        }
        if(month == 5) {
            this.selectedBulan.value = '5'
            this.selectedBulan.text = 'Mei'
        }
        if(month == 6) {
            this.selectedBulan.value = '6'
            this.selectedBulan.text = 'Juni'
        }
        if(month == 7) {
            this.selectedBulan.value = '7'
            this.selectedBulan.text = 'Juli'
        }
        if(month == 8) {
            this.selectedBulan.value = '8'
            this.selectedBulan.text = 'Agustus'
        }
        if(month == 9) {
            this.selectedBulan.value = '9'
            this.selectedBulan.text = 'September'
        }
        if(month == 10) {
            this.selectedBulan.value = '10'
            this.selectedBulan.text = 'Oktober'
        }
        if(month == 11) {
            this.selectedBulan.value = '11'
            this.selectedBulan.text = 'November'
        }
        if(month == 12) {
            this.selectedBulan.value = '12'
            this.selectedBulan.text = 'Desember'
        }
    },
    cekData(value) {
        this.$store.state.loadingScreen = true
        let data = this.datas[value]
        let unix = data.unix
        let payload = {
            unix: unix,
            bulan: this.selectedBulan.value,
            idPegawai: this.idPegawai,
            limit: this.size,
            pageIn: this.page,
            tahun: this.selectedTahun.value,
            fungsi: this.searchSelectedFungsi.value,
            approve: this.approve.value
        }
        DataApi.post("salary/magang/approve", payload)
        .then( response => {
            let res = response.data
            if(res.success == true) {
                this.datas = res.data.data
                this.checkAll = res.data.checkAll
                this.totalRow = res.data.totalRow
                this.firstPage = (((this.page - 1) * this.size) + 1 )
                this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                this.totalPage = Math.floor(this.totalRow/this.size)
                let modAr = this.totalRow%this.size
                if(modAr != 0) {
                    this.totalPage = this.totalPage + 1
                } else {
                    //
                }
            }
            this.$store.state.loadingScreen = false
        })
    },
    cekAllData(value) {
        let status = ''
        if(value == true) {
            status = 'Y'
        } else {
            status = 'T'
        }
        this.$store.state.loadingScreen = true
        let payload = {
            bulan: this.selectedBulan.value,
            idPegawai: this.idPegawai,
            limit: this.size,
            pageIn: this.page,
            tahun: this.selectedTahun.value,
            fungsi: this.searchSelectedFungsi.value,
            approve: status
        }
        DataApi.post("salary/magang/approve/all", payload)
        .then( response => {
            let res = response.data
            if(res.success == true) {
                this.datas = res.data.data
                this.checkAll = res.data.checkAll
                this.totalRow = res.data.totalRow
                this.firstPage = (((this.page - 1) * this.size) + 1 )
                this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                this.totalPage = Math.floor(this.totalRow/this.size)
                let modAr = this.totalRow%this.size
                if(modAr != 0) {
                    this.totalPage = this.totalPage + 1
                } else {
                    //
                }
            }
            this.$store.state.loadingScreen = false
        })
    },
    getDataRole() {
        this.$store.state.loadingScreen = true
        DataApi.get("pegawai/role/cek")
        .then( response => {
            let res = response.data
            if(res.success == true) {
                if(res.data.superSdm == 'Y') {
                    this.flagSDM = 'Y'
                } else {
                    this.flagSDM = 'T'
                }
            }
            this.$store.state.loadingScreen = false
        })
    },
    getDataApprove() {
        this.dataApprove = [
            { text: 'Semua', value: '' },
            { text: 'Disetujui', value: 'Y' },
            { text: 'Belum Disetujui', value: 'T' }
        ]
    },
    exportPdf() {
        this.$store.state.loadingScreen = true
        let payload = {
            bulan: this.selectedBulan.value,
            tahun: this.selectedTahun.value
        }
        DataApi.post("/export/salary/magang/lihat/pdf", payload , {responseType: 'blob'})
        .then(res => {
            let response = res.data
            const url = URL.createObjectURL(new Blob([response], {
                type: 'application/pdf'
            }))
            window.open(url)
            this.$store.state.loadingScreen = false
        })
    },
    approveSpv() {
        if(this.flagSDM == 'Y') {
            this.approveManager()
        } else {
            this.$store.state.loadingScreen = true
            let keteranganSDM = this.keteranganSDM
            let payload = {
                keterangan: keteranganSDM
            }
            DataApi.post("salary/magang/approve/sdm", payload)
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.approvedModal = false
                    this.getData()
                    this.approve.value = ''
                    this.approve.text = ''
                    this.page = 1
                }
                this.$store.state.loadingScreen = false
            })
        }
    },
    approveManager() {
        this.$store.state.loadingScreen = true
        let keteranganSDM = this.keteranganSDM
        let payload = {
            keterangan: keteranganSDM
        }
        DataApi.post("salary/magang/approve/supersdm", payload)
        .then( response => {
            let res = response.data
            if(res.success == true) {
                this.approvedModal = false
                this.getData()
                this.approve.value = ''
                this.approve.text = ''
                this.page = 1
            }
            this.$store.state.loadingScreen = false
        })
    }
},
mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.getDataApprove()
        this.getDataBulan()
        this.getDataTahun()
        this.setDate()
        this.getSearchDataFungsi()
        this.getDataRole()
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}

</style>